import React from 'react';
import { Bets } from '@alien-platform/bo-core';
import dayjs from 'dayjs';

import { Row } from '@/types/general';
import { HorizontalTable } from '@/components/core/horizontal-table';

export function BetDetailsTable({ betData }: { betData: Bets }): React.JSX.Element {
  const tableData: Row[] = [
    {
      label: {
        text: 'Bet Amount',
      },
      value: {
        text: `${betData?.betAmount || 0}`,
      },
    },
    {
      label: {
        text: 'Odds',
      },
      value: {
        text: betData?.winOdds || 0,
      },
    },
    {
      label: {
        text: 'Before Balance',
      },
      value: {
        text: `${betData?.playerBefore.wallet.inUSD.balance || 0}`,
      },
    },
    {
      label: {
        text: 'After Balance',
      },
      value: {
        text: `${betData?.playerAfter?.wallet?.inUSD?.balance || 0}`,
      },
    },
    {
      label: {
        text: 'Game Name',
      },
      value: {
        text: betData?.game?.title,
      },
    },
    {
      label: {
        text: 'Game Provider',
      },
      value: {
        text: betData?.game?.originalProvider,
      },
    },
    {
      label: {
        text: 'Bet ID',
      },
      value: {
        text: betData?.betId,
      },
    },
    {
      label: {
        text: 'PL',
      },
      value: {
        text: betData?.pl,
      },
    },
    {
      label: {
        text: 'Placed At',
      },
      value: {
        text: betData?.placedAt ? dayjs(betData?.placedAt).format('YYYY-MM-DD - HH:mm:ss') : '',
      },
    },
    {
      label: {
        text: 'Settled At',
      },
      value: {
        text: betData?.settledAt ? dayjs(betData?.settledAt).format('YYYY-MM-DD - HH:mm:ss') : '',
      },
    },
  ];

  return <HorizontalTable header="Status Update" status={betData.status} tableData={tableData} />;
}
